<template>
  <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.1946 0L14.8887 8.2918H23.6073L16.5538 13.4164L19.248 21.7082L12.1946 16.5836L5.14116 21.7082L7.83532 13.4164L0.781902 8.2918H9.50041L12.1946 0Z" fill="#D2A400"/>
  </svg>
</template>
